<template>
  <v-row class="map-height">
    <v-col cols="12" v-if="systemData">
      <l-map v-if="mapCentered.lat" :zoom="mapCentered.zoom" :center="getCenter" style="height: 100%; width: 100%">
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker v-for="item in systemData" :key="item.id"
          :lat-lng="[item.geolat ? item.geolat : 0, item.geolng ? item.geolng : 0]"
          v-on:click="$emit('markerClicked', item)">
          <l-tooltip :content="item.companyname" />
          <l-icon :icon-anchor="staticAnchor" class-name="someExtraClass">
            <img :src="chooseMapPin(item.authlevel, 'map')" width="30px" />
            <!-- <v-icon size="25" :color="chooseMapPin(item.authlevel)">mdi-google-maps</v-icon> -->
          </l-icon>
        </l-marker>
      </l-map>
    </v-col>
    <div id="legends" v-if="!(solarOption && solarOption.value)">
      <ul>
        <li><img :src="chooseMapPin('11', 'map')" width="20px" /> {{ "lng_service_partner_txt" | translate }}</li>
        <li><img :src="chooseMapPin('12', 'map')" width="20px" /> {{ "lng_dealer_service_partner_txt" | translate }}</li>
        <li><img :src="chooseMapPin('7', 'map')" width="20px" /> {{ "lng_service_partner_solar_txt" | translate }}</li>
        <li><img :src="chooseMapPin('8', 'map')" width="20px" /> {{ "lng_dealer_service_partner_solar_txt" | translate }}</li>
      </ul>
    </div>
  </v-row>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon, LTooltip } from "vue2-leaflet";
import { translateFunc } from "../../common/Filters.js"
import { solarRoleIds } from '../../common/Constant'

export default {
  name: "AdminSystemsMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LTooltip
  },
  props: {
    mapType: {
      type: String,
      default: "system"
    },
    systemData: {
      type: Array,
      default: () => []
    },
    mapCentered: {
      type: Object,
      default: () => { }
    },
    solarOption: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      zoom: undefined,
      center: L.latLng(56.426264, 9.957401),
      staticAnchor: [16, 37],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      systems: []
    }
  },
  watch: {
    systemData: function (newVal) {
      // if(newVal.length){
      //   this.center = newVal[0].geolat ? L.latLng(newVal[0].geolat, newVal[0].geolng)
      //   : L.latLng(newVal[0].system.geolat, newVal[0].system.geolng);
      // }
      // this.systems = [...newVal];
      // this.sortSystemData(newVal);
    },
    mapCentered: function (newVal) {
      if (newVal) {
        this.center = newVal.lat ? L.latLng(newVal.lat, newVal.lng)
          : L.latLng(56.426264, 9.957401);
        this.zoom = newVal.zoom
      }
    }
  },
  computed: {
    getCenter() {
      return L.latLng(this.mapCentered.lat, this.mapCentered.lng)
    }
  },
  methods: {
    sortSystemData() {
      this.systems.sort((a, b) => {
        if (a.sysstate !== "1") { return -1; }
        return 0;
      });
    },
    chooseMapPin(status, type) {
      // if (status === "0") {
      //   return type === "map" ? require("../../assets/icons/green-pin.png") : "status-0";
      // } else if (status === "1") {
      //   return type === "map" ? require("../../assets/icons/red-pin.png") : "status-1";
      // } else {
      //   return type === "map" ? require("../../assets/icons/grey-pin.png") : "status-other";
      // }
      if (status === "0") {
        return require("../../assets/icons/green-pin.png");
      } else if (status === "1") {
        return require("../../assets/icons/red-pin.png");
      // } else if (solarRoleIds.includes(status)) {
      //   if (this.solarOption && this.solarOption.value)
      //     return require("../../assets/icons/yellow-pin.png");
      //   else
      //     return require("../../assets/icons/green-pin.png");
      } else if (status === "10") {
        return require("../../assets/icons/lightgreen-pin.png");
      } else if (status === "11") {
        return require("../../assets/icons/blue-pin.png");
      } else if (status === "12") {
        return require("../../assets/icons/green-pin.png");
      } else if (status === "5") {
        return require("../../assets/icons/teal-pin.png");
      } else if (status === "6") {
        return require("../../assets/icons/yellow-pin.png");
      } else if (status === "7") {
        return require("../../assets/icons/orange-pin.png");
      } else if (status === "8") {
        return require("../../assets/icons/magenta-pin.png");
      } else if (status === "9") {
        return require("../../assets/icons/darkblue-pin.png");
      } else {
        return require("../../assets/icons/grey-pin.png");
      }
    },
    renderMarkersTooltip(item) {
      if (item.sysstate === "0") {
        return translateFunc('lng_marker_green');
      } else if (item.sysstate === "1") {
        return translateFunc('lng_marker_red');
      } else {
        return translateFunc('lng_marker_grey');
      }
    },
  }
}
</script>
<style scoped>
#legends {
  position: absolute;
  top: 20%;
  left: 10px;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8); /* Semi-transparent white background */
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* Light shadow effect */
  z-index: 999; /* Ensure legends appear above the map */
}

#legends ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#legends li {
  margin-bottom: 5px;
}
</style>